import React from 'react'
import Combaintop from '../Components/Combaintop/Top';
import Combainbottom from '../Components/Combainbottom/Combainbottom';
// import Breadcrumbs from '../Components/banner/New-banner';

import OTPVerification from '../Components/Otp';
function Verify() {
    return (
        <>
            <Combaintop />
            {/* <Breadcrumbs/> */}
            <OTPVerification />
            <Combainbottom />
        </>
    )
}

export default Verify;